export default __webpack_public_path__ + "static/tab7Img-e70ed33c960458b03e433791a36b1377.png";